module.exports = __webpack_public_path__ + "img/C-suite_wc.ea3d5924.svg";